<template>
  <div class="wrapper">
    <el-form class="search-form" inline size="mini">
      <el-form-item>
        <el-radio-group v-model='search.state' @change="handleSearch">
          <el-radio-button label=''>全部</el-radio-button>
          <el-radio-button v-for="item in StateMap" :label='item.value' :key="item.value">
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-input v-model='search.title' placeholder='模糊搜索产品名称' clearable @change="handleSearch" />
      </el-form-item>
      <el-form-item>
        <el-input v-model='search.id' placeholder='模糊搜索产品ID' clearable @change="handleSearch" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh-left" size="mini" @click="handleResetSearch">重置</el-button>
        <el-button v-if="userPermissions.indexOf('ai_tools__product_ingredients_list') !== -1"
                   icon="el-icon-s-data" size="mini" @click="handleShowIngredient">
          成分表
        </el-button>
      </el-form-item>
      <el-form-item style="float: right;">
        <product-ingredient-save ref="save" @success="handleSearch" />
        <product-ingredient-see ref="see" @success="handleSearch" />
        <product-ingredient-see-ocr ref="ProductIngredientSeeOcr" />
      </el-form-item>
    </el-form>
    <ml-table ref="TABLE" :api="apiList" :search="search" style="height: calc(100% - 100px)">
      <template slot="columns">
        <el-table-column type="selection" width="55" />
        <el-table-column label="ID" prop="id" width="55" show-overflow-tooltip />
        <el-table-column label="产品名称" prop="title" min-width="200" show-overflow-tooltip />
        <!--        <el-table-column label="产品条码" prop="barcode" min-width="120" show-overflow-tooltip />-->
        <el-table-column label="状态" width="100">
          <template v-slot="{row:{state}}">
            <span v-if="StateMap[state]" :style="`color: ${StateMap[state].color}`">{{ StateMap[state].label }}</span>
          </template>
        </el-table-column>
        <el-table-column label="成分图" align="left" min-width="150" class-name="pics">
          <template v-slot="{row:{ingredient_url}}">
            <div v-if="!Array.isArray(ingredient_url) || !ingredient_url.length">无</div>
            <template v-else>
              <el-image
                v-for="(item,i) in ingredient_url" :key="i"
                style="width: 40px; height: 40px"
                :src="item.url"
                :preview-src-list="[item.url]">
              </el-image>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="文本识别" prop="ocr" align="center" min-width="120">
          <template v-slot='{row}'>
            <el-button v-if="row.state === 'O' || row.state === 'D'" plain round size='mini' @click="handleSeeOcr(row)">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="成分分析" prop="propose_ai" align="center" min-width="120">
          <template v-slot='{row}'>
            <el-button v-if="row.state === 'D'" plain round size='mini' @click="handleSeeAi(row)">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="model_nm" label="解析模型" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column prop="ocr_at" label="识别时间" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column prop="ai_at" label="分析时间" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column prop="created_at" label="创建时间" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column prop="updated_at" label="修改时间" align="center" min-width="120" show-overflow-tooltip />
        <el-table-column width='150'>
          <template v-slot='{row}'>
            <el-button plain round size='mini' @click="handleEdit(row)">
              修改
            </el-button>
            <el-button plain round @click='handleDelete(row.id)' size='mini'>删除
            </el-button>
          </template>
        </el-table-column>
      </template>
      <template slot="footer">
        <ml-button @click.native="handleReset" text="批量重置解析" />
      </template>
    </ml-table>
    <!--  成分表  -->
    <el-dialog title='成分表' :visible.sync='ingredientDialog.show' width='75%' append-to-body
               :close-on-click-modal='false'>
      <div style="margin-bottom: 10px">
        <el-row :gutter="20">
          <el-col :span="4">
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleAiParseIngredientSearchList">
              查询
            </el-button>
          </el-col>
          <el-col :span="4" :offset="16">
            <el-button v-if="userPermissions.indexOf('ai_tools__product_ingredients_save') !== -1" type="warning"
                       icon="el-icon-refresh" size="mini" @click="handleAiParseIngredientRunSyncScript">
              同步AI解析成分
            </el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table ref="ingredientTable" v-loading="ingredientDialog.load" :data="ingredientDialog.list"
                  highlight-current-row border style="width: 100%">
          <el-table-column type="index" label="序号" width="70" align="center" />
          <el-table-column property="nm" label="成分" width="200" align="center" />
          <el-table-column property="model_nm" label="模型" min-width="200" align="center" />
          <el-table-column property="effect" label="作用" width="200" align="center" />
          <el-table-column property="allergy" label="刺激性/致敏性" width="200" align="center" />
          <el-table-column property="score" label="安全分" width="70" align="right" header-align="center" />
          <el-table-column property="remark" label="备注" width="300" align="center" />
        </el-table>
        <el-pagination style="margin-top: 15px"
          @size-change="handleAiParseIngredientPrivacySizeChange"
          @current-change="handleAiParseIngredientPrivacyPageChange"
          :current-page="ingredientDialog.pages.current_page"
          :page-sizes="[5, 10, 20, 50, 100]"
          :page-size="ingredientDialog.pages.page_size"
          layout="total, sizes, prev, pager, next"
          :total="ingredientDialog.pages.total">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import MlTable from '@/components/MlTable/index.vue'
import MlButton from '@/components/MlButton/index.vue'
import { productIngredientDelete, productIngredientList, productIngredientReset } from '@/api/product-ingredients'
import { aiParseIngredientSearchList, aiParseIngredientRunSyncScript } from '@/api/ai_parse_ingredient'
import ProductIngredientSave from '@/pages/product/ingredients/save.vue'
import ProductIngredientSee from '@/pages/product/ingredients/see-ingredient.vue'
import ProductIngredientSeeOcr from '@/pages/product/ingredients/see-ocr.vue'
import { mapGetters } from 'vuex'

/********* 状态 *********/
const StateMap = {
  N: { label: '未解析', color: '#909399', value: 'N' },
  H: { label: '需人工处理', color: '#fe5a1e', value: 'H' },
  O: { label: '文本已识别', color: 'rgba(255,49,118,0.67)', value: 'O' },
  F: { label: '解析失败', color: '#FE1E1E', value: 'F' },
  D: { label: '解析完成', color: '#24BA0CFF', value: 'D' },
  U: { label: '未配置', color: '#000', value: 'U' },
}
export default {
  name: 'ProductIngredientsList',
  components: { ProductIngredientSee, ProductIngredientSeeOcr, ProductIngredientSave, MlButton, MlTable },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  data() {
    return {
      StateMap,
      search: {
        state: '',
        title: '',
      },
      ingredientDialog: {
        show: false,
        load: true,
        query: {},
        list: [],
        pages: { current_page: 1, page_size: 10, total: 0 },
      },
    }
  },
  methods: {
    apiList: productIngredientList,
    /**
     * 查看
     * @param row
     */
    handleSeeAi: function(row) {
      this.$refs.see.interfaceSee(row)
    },
    handleSeeOcr: function(row) {
      this.$refs.ProductIngredientSeeOcr.interfaceSee(row)
    },
    handleReset: function() {
      const selection = this.$refs.TABLE.getSelection()
      const ids = selection.map(_ => {
        return _.id
      })
      const length = ids.length
      if (length <= 0) {
        this.$message.warning('请选择数据')
        return false
      }
      this.$confirm(
        `已选中${length}条数据确认重置吗？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
        await productIngredientReset({ ids })
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.handleSearch()
      })
    },
    /**
     * 编辑按钮
     * @param row
     * @return {Promise<void>}
     */
    async handleEdit(row) {
      this.$refs.save.interfaceEdit(row)
    },
    /** 删除按钮 */
    handleDelete(id) {
      this.$confirm('此操作将删除数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await productIngredientDelete({ id })
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.handleSearch()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleSearch: function() {
      this.$refs[`TABLE`].handleSearch && this.$refs[`TABLE`].handleSearch()
    },
    handleResetSearch: function() {
      this.search = {
        state: '',
        title: ''
      }
      this.$nextTick(() => {
        this.handleSearch()
      })
    },
    handleShowIngredient: function() {
      this.ingredientDialog.show = true
      this.ingredientDialog.list = []
      this.ingredientDialog.pages = { current_page: 1, page_size: 10, total: 0 }
      this.handleAiParseIngredientSearchList()
    },
    handleAiParseIngredientSearchList: async function() {
      this.ingredientDialog.load = true
      this.handleAiParseIngredientQueryWhere()
      const { list, pages } = await aiParseIngredientSearchList(this.ingredientDialog.query)
      this.ingredientDialog.list = list || []
      this.ingredientDialog.pages = pages || { current_page: 1, page_size: 10, total: 0 }
      this.ingredientDialog.load = false
    },
    handleAiParseIngredientQueryWhere: function() {
      this.ingredientDialog.query = {
        current_page: this.ingredientDialog.pages.current_page,
        page_size: this.ingredientDialog.pages.page_size,
      }
    },
    handleAiParseIngredientPrivacyPageChange(page) {
      this.ingredientDialog.pages.current_page = page
      this.handleAiParseIngredientSearchList()
    },
    handleAiParseIngredientPrivacySizeChange(size) {
      this.ingredientDialog.pages.page_size = size
      this.ingredientDialog.pages.current_page = 1
      this.handleAiParseIngredientSearchList()
    },
    handleAiParseIngredientRunSyncScript: async function() {
      await aiParseIngredientRunSyncScript()
    }
  }
}
</script>
<style lang="scss">
.product_ingredients_main {
  height: calc(100vh - 84px);

  .product_ingredients_main-inner {
    height: 100%;
  }

  .wrapper {
    background-color: #f7f8fa;
    height: 100%;
    padding: 18px;
  }

  .search-form {
    background: #fff;
    border-radius: 12px;
    padding: 12px 20px;
    margin-bottom: 20px;

    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }

  .ml-table-container {
    background: white;
    border-radius: 12px;
    padding: 12px 20px;
  }

  .el-image + .el-image {
    //margin-left: 10px;
  }

  .pics {
    padding: 0;

    .cell {
      line-height: 0;
    }
  }
}
</style>
